import React, { useEffect, useState } from 'react';
import {
  Backdrop, Modal, Typography, Box, Fade, DialogTitle, DialogContentText,
  DialogContent, Dialog, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TextField, TablePagination, Avatar, Button,
  Snackbar, Alert
} from '@mui/material';
import axios from 'axios';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

const AllReservateEnd = () => {
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [detailsReservation, setDetailsReservations] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // "success", "error", "info", "warning"
console.log(detailsReservation)
  const Clients = async () => {
    try {
      const response = await axios.get('https://softwaregestion-production-b8ad.up.railway.app/api/all-reservate');
      const finalizado = response.data.data.filter((item) => item.status === "finalizado");
      setClientes(finalizado);
    } catch (error) {
      console.error('Error al obtener clientes:', error);

    }
  };

  useEffect(() => {
    Clients();
  }, []);

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const extractedClients = clientes?.map(reserva => ({
    ...reserva.client,
    priceTotal: reserva.priceTotal,
    services: reserva.services,
    reservationId: reserva.id,
    status: reserva.status,
    paymentMethod: reserva.paymentMethod || 'efectivo'
  }));

  const filteredClients = extractedClients.filter(cliente =>
    cliente.name.toLowerCase().includes(search.toLowerCase()) ||
    cliente.lastName.toLowerCase().includes(search.toLowerCase())
  );

  const totalPrice = filteredClients.reduce((total, cliente) => total + cliente.priceTotal, 0);

  const efectivoTotal = filteredClients
    .filter(cliente => cliente.paymentMethod === 'efectivo')
    .reduce((total, cliente) => total + cliente.priceTotal, 0);

  const transferenciaTotal = filteredClients
    .filter(cliente => cliente.paymentMethod === 'transferencia')
    .reduce((total, cliente) => total + cliente.priceTotal, 0);

  const tarjetaTotal = filteredClients
    .filter(cliente => cliente.paymentMethod === 'tarjetas')
    .reduce((total, cliente) => total + cliente.priceTotal, 0);

  const handleClickOpen = (scrollType, reserva) => {
    setOpen(true);
    setDetailsReservations(reserva);
  };

  const handleClose = () => {
    setOpen(false);
    setDetailsReservations(null);
  };

  const handleMoveAllToHistory = async () => {
    try {
      const response = await axios.post('https://softwaregestion-production-b8ad.up.railway.app/api/reservations/move-to-history', {
        reservations: clientes.map((reserva) => reserva.id)
      });

      if (response.status === 200) {
        setSnackbarSeverity('success');
        setSnackbarMessage('Reservas movidas al historial correctamente.');
        setSnackbarOpen(true);
        Clients();
      }
    } catch (error) {
      console.error('Error al mover reservas al historial:', error);
      setSnackbarSeverity('error');
      setSnackbarMessage('Ocurrió un error al mover las reservas al historial.');
      setSnackbarOpen(true);
    }
  };



  // Función para cerrar el Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden', padding: 2 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{ mb: 2 }}
          onClick={handleMoveAllToHistory}
        >
          Cerrar día
        </Button>
      

        {/* Totales arriba */}
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Paper elevation={3} sx={{ p: 2, flex: 1, minWidth: 200, textAlign: 'center' }}>
            <Typography variant="h6">Tarjetas de crédito y/o débito</Typography>
            <Typography variant="h5" color="warning.main">${tarjetaTotal}</Typography>
          </Paper>
          <Paper elevation={3} sx={{ p: 2, flex: 1, textAlign: 'center' }}>
            <Typography variant="h6">Efectivo</Typography>
            <Typography variant="h5" color="success.main">${efectivoTotal}</Typography>
          </Paper>
          <Paper elevation={3} sx={{ p: 2, flex: 1, textAlign: 'center' }}>
            <Typography variant="h6">Transferencia</Typography>
            <Typography variant="h5" color="info.main">${transferenciaTotal}</Typography>
          </Paper>
          <Paper elevation={3} sx={{ p: 2, flex: 1, textAlign: 'center' }}>
            <Typography variant="h6">Total </Typography>
            <Typography variant="h5" color="primary">${totalPrice}</Typography>
          </Paper>
        </Box>

        {/* Buscador y botón */}
        <TextField
          label="Buscar Cliente"
          variant="outlined"
          fullWidth
          margin="normal"
          value={search}
          onChange={handleSearch}
        />

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>WhatsApp</TableCell>
                <TableCell>Correo electrónico</TableCell>
                <TableCell>Total a pagar</TableCell>
                <TableCell>Estado del servicio</TableCell>
                <TableCell>Ver servicios</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredClients?.map((cliente) => (
                <TableRow key={cliente.reservationId}>
                  <TableCell>
                    <Avatar alt={cliente.name} src={cliente.avatar} />
                  </TableCell>
                  <TableCell>{cliente.name} {cliente.lastName}</TableCell>
                  <TableCell>{cliente.phone}</TableCell>
                  <TableCell>{cliente.email}</TableCell>
                  <TableCell>${cliente.priceTotal}</TableCell>
                  <TableCell>{cliente.status}</TableCell>
                  <TableCell>
                    <Button variant='contained' onClick={() => handleClickOpen('paper', cliente)}>Ver</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Modal de detalles */}
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Detalles de la Reserva</DialogTitle>
        <DialogContent dividers>
          {detailsReservation ? (
            <>
              <DialogContentText>
                <strong>Cliente:</strong> {detailsReservation?.client?.name} {detailsReservation?.client?.lastName}
              </DialogContentText>
              <DialogContentText>
                <strong>Servicios:</strong>
                <ul>
                  {detailsReservation?.services?.map((service, index) => (
                    <li key={index}>{service.servicio} ${service.precio}</li>
                  ))}
                </ul>
              </DialogContentText>
              <DialogContentText sx={{ textAlign: "center" }}>
                <strong>Monto Total:</strong> ${detailsReservation?.priceTotal}
              </DialogContentText>
            </>
          ) : (
            <DialogContentText>No hay datos disponibles.</DialogContentText>
          )}
        </DialogContent>
      </Dialog>

      {/* Snackbar para alertas */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AllReservateEnd;
